import React from "react";
import { translate } from "react-i18next";
import Button from "../../../components/Button";
import InputForm from "../../../components/InputForm";
import LabelForm from "../../../components/LabelForm";

const PersonData = (props)=>{
    const {t} = props;
    return(
        <div className="col-xs-12 no-padding">
            <h4 className="theme-color">{props.person.fullName}</h4>

            <div className="col-xs-12 np-padding">
                <fieldset>
                    <legend>Identificación</legend>
                    
                    <div className="col-xs-12 col-sm-4 col-md-2">
                        <LabelForm text={t('content.modal_hc.offer_number')} />
                        <InputForm id="id" value={props.person.id} handleChange={props.handleChange} disabled />
                    </div>	

                    <div className="col-xs-12 col-sm-6 col-md-9">
                        <LabelForm text={t('content.modal_hc.address')} />
                        <InputForm id="address" value={props.person.address} handleChange={props.handleChange} disabled />
                    </div>
                    <div className="col-xs-12 col-sm-2 col-md-1">
                        <Button 
                            class="btn-info button-min"  
                            action={props.edit}
                            styles={{marginTop:19, float:'right'}}
                            text='EDITAR'
                        />
                    </div>
                    
                    <div className="col-xs-12 col-sm-2 col-md-1">
                        <LabelForm text={t('content.modal_hc.birthday')} />
                        <InputForm id='birthday' value={props.person.birthday} handleChange={props.handleChange} disabled />
                    </div>
                    <div className="col-xs-12 col-sm-2 col-md-1">
                        <LabelForm text={t('content.modal_hc.age')} />
                        <InputForm id="age" value={props.person.age} handleChange={props.handleChange} disabled />                        
                    </div>
                    <div className="col-xs-12 col-sm-2 col-md-1">
                        <LabelForm text={t('content.modal_hc.sex')} />
                        <InputForm id="sex" value={props.person.sex} handleChange={props.handleChange} disabled />
                    </div>
                    <div className="col-xs-12 col-sm-2 col-md-1">
                        <LabelForm text={t('content.modal_hc.civil_status')} />
                        <InputForm id="civilStatus" value={props.person.civilStatus} handleChange={props.handleChange} disabled />
                    </div>

                    <div className="col-xs-12 col-sm-2" >
                        <LabelForm text={t('content.modal_hc.scholarship')} />
                        <InputForm id="scholarship" value={props.person.scholarship} handleChange={props.handleChange} disabled />
                    </div>
                    <div className="col-xs-12 col-sm-2" >
                        <LabelForm text={t('content.modal_hc.job_profile')} />
                        <InputForm id="jobProfile" value={props.person.jobProfile} handleChange={props.handleChange} disabled />
                    </div>
                    <div className="col-xs-12 col-sm-4" >
                        <LabelForm text={t('content.modal_hc.phones')} />
                        <InputForm id="phones" value={props.person.phones} handleChange={props.handleChange} disabled />
                    </div>

                    {props.showPatient &&
                        <fieldset className="col-xs-12 no-padding">
                            <legend>Paciente</legend>
                            <div className="col-xs-12 col-md-2" >
                                <LabelForm text={t('content.modal_hc.patient_name')} />
                                <InputForm id="patientName" value={props.patient.name} handleChange={props.handleChange} disabled />
                            </div>
                            <div className="col-xs-12 col-md-4" >
                                <LabelForm text="Apellidos Paciente" />
                                <InputForm id="patientLastnames" value={props.patient.lastnames} handleChange={props.handleChange} disabled />
                            </div>
                            <div className="col-xs-12 col-md-1" >
                                <LabelForm text={t('content.modal_hc.relationship')} />
                                <InputForm id="patientRelationship" value={props.patient.relationship} handleChange={props.handleChange} disabled />
                            </div>
                            <div className="col-xs-12 col-md-5" >
                                <LabelForm text={t('content.modal_hc.health_facility')} />
                                <InputForm id="patientHealthFacility" value={props.patient.healthFacility} handleChange={props.handleChange} disabled />
                            </div>                            
                        </fieldset>
                    }
                </fieldset>
            </div>
        </div>
    )
}

export default translate('translations')(PersonData);